import { Point, NumPair, NumberUtils } from '../Misc/Utils';
import { PointOps } from '../Graphics/PointOps';
import { SelectionBox, SelectionCircle } from '../CanvasGui/SelectionBox';
import { Constants } from '../Misc/Constants';
import { ObjectType } from './ObjectTypeEnum';
import { Colour } from '@/lib/bezieLib/Colour/Colour';
import { Colourable, ColourIndex, ColouringMode, ObjColourManager } from '../Colour/Colourable';
import { UIUpdate } from '../UI/UIUpdate';
import { InputRegisterer } from '../Input/InputHandler';
/**
 * Base object for anything that is drawn on the canvas
 */
export abstract class BObject implements Colourable{

    protected abstract readonly TYPE: ObjectType;
    protected id : number = -1
    public name: String = "Unnamed-Object"

    protected centre : Point = [0,0]
    protected angle : number = 0
    protected scaleFactor : Point = [1,1]
    protected opacity: number = Constants.OPAQUE;

    //protected xy : NumPair = [0,0]
    protected wh : NumPair
    
    protected isVisible : boolean // false if user marks invisible
    protected selBox : SelectionBox
    protected isSelected : boolean
    protected uniformScaling : boolean = false

    protected frameRange : NumPair
    protected curFrame : number

    protected colorMgr: ObjColourManager = new ObjColourManager();

    constructor(center : NumPair, twh : NumPair, frameRange : NumPair ){
        this.centre = center;
        this.wh = twh;
        //this.computeXY();
        this.angle = 0;
        this.frameRange = frameRange;
        this.curFrame = 0;
        this.isVisible = true;
        this.isSelected = false;
        this.selBox = new SelectionBox();
    }
    
    //DRAW

    draw(canvasCtx : CanvasRenderingContext2D, playing : boolean, curFrame : number) : void{
        this.curFrame = curFrame;
        if(this.isVisible && this.isActive()){
            this.drawObj(canvasCtx, playing, curFrame);
        }
    }

    protected abstract drawObj(canvasCtx : CanvasRenderingContext2D, playing : boolean, curFrame : number) : void;

    drawControlPoints(canvasCtx : CanvasRenderingContext2D, curFrame : number) : void{
        this.selBox.draw(canvasCtx, this.centre, this.wh);
    }
    
    //SELECTION CHECK

    checkSelection( point : Point ) : boolean {
        this.isSelected = this.isWithinBounds(point);
        return this.isSelected;
    }

    checkTransformPointSelection(point : Point) : boolean {
        return this.selBox.checkSelection(point, this.wh);
    }

    isWithinBounds( point: Point ):boolean{
        if(this.boundsCheck(point)){
            return true;
        }
        return false;
    }

    protected boundsCheck(localPoint: Point): boolean{
        return localPoint[0] > -this.wh[0]/2 && localPoint[0] < this.wh[0]/2
        && localPoint[1] > -this.wh[1]/2 && localPoint[1] < this.wh[1]/2;
    }

    //TRANSFORMATION

    protected globalToLocal(toTx: Point): Point{
        return toTx;
    }

    protected localToGlobal(toTx: Point): Point{
        return toTx;
    }

    //EDIT

    edit(lastMousePoint : Point, curMousePoint : Point) : void {
        //console.log("last:"+lastMousePoint+" cur:"+curMousePoint);
        if(NumberUtils.isNumber(lastMousePoint) && NumberUtils.isNumber(curMousePoint)){
            lastMousePoint = [ Number(lastMousePoint[0]), Number(lastMousePoint[1])];
            curMousePoint = [ Number(curMousePoint[0]) , Number(curMousePoint[1]) ];
            var change = PointOps.subtract(curMousePoint, lastMousePoint);
            this.editImplm(curMousePoint, change);
        }
    }

    /**
     * Method that takes care of editing an object. 
     * In this case the base object checks the bounds to know if transform point/rotation point or scaling is done
     * @param curMousePoint 
     * @param change 
     */
    protected editImplm(curMousePoint: Point, change: Point):void{
        if(this.selBox.isTransformPointSelected()){
            if(this.selBox.isScaling()){
                this.scale(curMousePoint);
            }else if(this.selBox.isRotation()){
                this.rotate(change);
            }
        }else{
            this.moveBy(change);
        }
    }

    isEditableStructure(): boolean{ return false;}

    editStructure(start: boolean, inputRegisterer: InputRegisterer):void{}

    public moveBy( dist: Point) : void{
        this.moveCentreBy(dist);
    }

    protected rotate(change : Point) : void{
        this.setAngle(this.angle - change[0]); // '-' makes object rotate counter clock wise on dragging cursor to right and clockwise on dragging cursor to left
    }

    protected scalingImplm(selectedTxPointIndex: SelectionCircle, localCurMousePoint: Point): void{
        //should be used by the inherting entity
    }

    protected scale(curMousePoint: Point): void{
        var index = this.selBox.getTransformPointIndex();
        if(index!=-1){
            var localCursor = this.globalToLocal(curMousePoint);
            this.scalingImplm(index, localCursor);
        }
    }

    /*
    protected scale(curMousePoint: Point): void{
        //var computed = change;
        var index  = this.selBox.getTransformPointIndex();
        if(index!=-1){
            console.log("case:"+index);
            var localCursor = this.globalToLocal(curMousePoint);
            //var newWH = [ Math.abs(localCursor[0]) + this.wh[0]/2, Math.abs(localCursor[1])+this.wh[1]/2 ];
            var oppPoint = Constants.ORIGIN;
            switch(index){
                case SelectionCircle.TOP_LEFT:
                    //top left
                    //newLocalCentre  = [ localCursor[0] + newWH[0]/2, localCursor[1] + newWH[1]/2 ];
                    oppPoint = [ this.wh[0]/2, this.wh[1]/2 ]; 
                    break;
                case SelectionCircle.TOP_RIGHT:
                    //top right
                    oppPoint = [ -this.wh[0]/2, this.wh[1]/2 ]; 
                    //newLocalCentre  = [ localCursor[0] - newWH[0]/2, localCursor[1] + newWH[1]/2 ];
                    break;
                case SelectionCircle.BOTTOM_RIGHT:
                    //bottom right
                    oppPoint = [ -this.wh[0]/2, -this.wh[1]/2 ]; 
                    //newLocalCentre  = [ localCursor[0] - newWH[0]/2, localCursor[1] - newWH[1]/2 ];
                    break;
                case SelectionCircle.BOTTOM_LEFT:
                    //bottom left
                    oppPoint = [ this.wh[0]/2, -this.wh[1]/2 ]; 
                    //newLocalCentre  = [ localCursor[0] + newWH[0]/2, localCursor[1] - newWH[1]/2 ];
                    break;
                case SelectionCircle.TOP:
                    oppPoint = [ 0, this.wh[1]/2 ]; 
                    break;
                case SelectionCircle.RIGHT:
                    oppPoint = [ -this.wh[0]/2, 0 ]; 
                    break;
                case SelectionCircle.BOTTOM:
                    oppPoint = [ 0, -this.wh[1]/2 ]; 
                    break;
                case SelectionCircle.LEFT:
                    oppPoint = [ this.wh[0]/2, 0 ]; 
                    break;
            }

            var newLocalCentre = PointOps.mid(localCursor, oppPoint);
            this.setCentre(this.localToGlobal(newLocalCentre));
            this.setWH(PointOps.difference(oppPoint, localCursor));
        }
    }
    */

    /*protected scale(curMousePoint : Point) : void{
        var index  = this.selBox.getTransformPointIndex();


        if(index!=-1){

            if(this.uniformScaling){

                switch(index){
                    case 0:
                        //top left
                        var diff = this.xy[0] - curMousePoint[0];
                        this.wh = [this.wh[0]+diff,this.wh[1]+diff];
                        this.xy = [this.xy[0]-diff, this.xy[1]-diff];
                        break;
                    case 1:
                        //top right
                        var diff = curMousePoint[0]-(this.xy[0]+this.wh[0]);
                        this.xy = [this.xy[0], this.xy[1]-diff];
                        this.wh = [this.wh[0]+diff, this.wh[1]+diff];
                        break;
                    case 2:
                        //bottom right
                        var diff = curMousePoint[0]-(this.xy[0]+this.wh[0]);
                        this.wh = [this.wh[0]+diff,this.wh[1]+diff];
                        break;
                    case 3:
                        //bottom left
                        var diff = this.xy[0] - curMousePoint[0];
                        this.xy = [this.xy[0]-diff, this.xy[1]];
                        this.wh = [this.wh[0]+diff, this.wh[1]+diff];

                        break;
                }

            } else {
    
                //Non uniform scaling
            
                switch(index){
                    case 0:
                        //top left
                        this.wh = PointOps.add(this.wh, PointOps.subtract(this.xy, curMousePoint));
                        this.xy = curMousePoint;

                        break;
                    case 1:
                        //top right
                        //var topRight : Point = [this.xy[0]+this.wh[0], this.xy[1]];
                        var height = PointOps.add(this.wh, PointOps.subtract(this.xy, curMousePoint))[1];
                        var width = curMousePoint[0] - this.xy[0];
                        
                        this.xy = [this.xy[0], curMousePoint[1]];
                        this.wh = [width, height];
                        break;
                    case 2:
                        //bottom right
                        var height = curMousePoint[1] - this.xy[1];
                        var width = curMousePoint[0] - this.xy[0];
                        this.wh = [width, height];
                        break;
                    case 3:
                        //bottom left
                        //var bottomLeft : Point = [this.xy[0], this.xy[1]+this.wh[1]];
                        var height = curMousePoint[1] - this.xy[1];
                        var width = PointOps.add(this.wh, PointOps.subtract(this.xy, curMousePoint))[0];
                        
                        this.xy = [curMousePoint[0], this.xy[1]];
                        this.wh = [width, height];
                        break;
                }
            }

            this.computeCentre();
        }
    }*/


    //CENTRE

    getCentre() : Point {
        return this.centre;
    }

    public setCentre(tCentre : Point) : void{
        this.centre = tCentre;
        //this.computeXY();
    }

    /*protected computeCentre() : void {
        this.centre =  [this.xy[0]+(this.wh[0]/2), this.xy[1]+(this.wh[1]/2) ];
        
        console.log("center:" + this.centre);
    }*/

    protected moveCentreBy(dist : Point) : void{
        this.setCentre(PointOps.add(this.centre, dist));
        //this.computeXY();
    }

    protected getPointRelativeToCentre(point : Point) : Point{
        return PointOps.subtract(point, this.centre);
    }

    //XY

    /*protected computeXY() : void{
        this.xy = [this.centre[0] - (this.wh[0]/2), this.centre[1] - (this.wh[1]/2)];
        //console.log("xy:"+this.xy);
    }*/

    
    //WH

    getWH() : Point {
        return this.wh;
    }

    public setWH(tWh : Point) :void{
        if(NumberUtils.isNumber(tWh)){
            this.wh = [Number(tWh[0]), Number(tWh[1])];
            //console.log("wh set to"+this.wh);
            //this.computeXY();
        }
    }

    //ANGLE

    getAngle() : number {
        return this.angle;
    }

    public setAngle(angle : number) : void{
        if(angle != null && Number(angle)!=NaN){
            this.angle = Number(angle);
        }
    }

    //OPACITY

    getOpacity() : number{
        return this.opacity;
    }

    public setOpacity(alpha: number): void{
        if(alpha!=null && Number(alpha)!=NaN){
            this.opacity = NumberUtils.fitToRange(alpha, 0, 1);
        }
    }

    //OTHERS

    public isActive() : boolean{
        return NumberUtils.isWithinRange(this.curFrame, this.frameRange[0], this.frameRange[1]); 
    }

    public isDead() : boolean{
        return this.curFrame > this.frameRange[1];
    }

    isMotionObject() : boolean{
        return false;
    }

    isObjectSelected() : boolean {
        return this.isSelected;
    }

    getImageSrc() : String{
        return "";
    }

    public setId(name:number){
        this.id = name;
        if(this.name == "Unnamed-Object"){
            this.name = "Unnamed-Object "+this.id;
        }
    }

    getId() : number{
        return this.id;
    }

    public getIsVisible() :boolean{
        return this.isVisible;
    }

    public setIsVisible(val : boolean){
        this.isVisible = val;
    }

    getFrameRange() : NumPair{
        return this.frameRange;
    }

    setFrameRange(frameRange : NumPair) : void{
        if(frameRange[0] < frameRange[1] && frameRange[0] >= 0 && NumberUtils.isNumber(frameRange)){
            this.frameRange = [Number(frameRange[0]), Number(frameRange[1])];
        }
    }

    updateFrameRange(sceneTotalFrames: number): void{
        if(this.frameRange[1] >= sceneTotalFrames){
            this.frameRange[1] = sceneTotalFrames-1;
            if(this.frameRange[0] > this.frameRange[1]){
                this.frameRange[0] = this.frameRange[1]-1;
            }
        }
        console.log("frame range updated to "+this.frameRange);
    }

    addDelay(framesToDelay : number){
        if(framesToDelay){
            this.frameRange = NumberUtils.addToNumPair(framesToDelay, this.frameRange);
        }
    }

    //Method to call when position values for animation needs to be calculated.
    update(curFrame : number) : void{
        this.curFrame = curFrame;

        if(this.curFrame == 0){
            this.prepare();
        }
    }

    //Called once before frame 0
    protected prepare() : void{

    }

    resetAnimationPos() : void{
        //do nothing.
    }

    //COLOUR
    isColourable(): Boolean{
        return false;
    }
    getColour(index: ColourIndex): Colour {
        return this.colorMgr.getColour(index);
    }
    setColour(index: ColourIndex, colour: Colour): void {
        this.colorMgr.setColour(colour, index);
        UIUpdate.updatePropertiesUI(this);
    }
    setColouringMode(mode: ColouringMode):void{
        console.log("colorming mdoe set to:"+mode);
        this.colorMgr.setColouringMode(mode);
    }
    getColouringMode():ColouringMode{
        return this.colorMgr.getColouringMode();
    }
    
    public abstract clone() : BObject;

    protected duplicate(dupObj : BObject) : void{
        dupObj.setCentre([this.centre[0], this.centre[1]]);
        dupObj.setAngle(this.angle);
        dupObj.scaleFactor = [this.scaleFactor[0],this.scaleFactor[1]];
        dupObj.setOpacity(this.opacity);
        dupObj.wh = [this.wh[0], this.wh[1]];

        dupObj.curFrame = this.curFrame;
        dupObj.isVisible = this.isVisible;
        dupObj.isSelected = false;
        dupObj.uniformScaling = this.uniformScaling;
        dupObj.frameRange = [this.frameRange[0], this.frameRange[1]];
        dupObj.curFrame = this.curFrame;
        dupObj.colorMgr = this.colorMgr.clone();
    }
}